import { render, staticRenderFns } from "./MerchantLogo.vue?vue&type=template&id=2141554c&lang=pug"
import script from "./MerchantLogo.vue?vue&type=script&lang=ts"
export * from "./MerchantLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports